<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="800">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="partido-title">{{ cardTitle }}</span>
          <hr v-if="type !== 'notification'">
          <br v-if="type === 'notification'">
          <span v-if="type === 'notification'" color="grey-lighten-1" class="subheadline">{{ cardDetail }}</span>
          <v-card-text>
            <form v-if="type === 'notification'">
              <v-layout row wrap>
                <v-flex xs8 pr-2>
                  <SelectItems v-model="personas" :items="personasNames" itemText="nombre" itemValue="id"
                    label="Grupos a comunicar" prepend-icon="fa-user" :loading="loadingCriterion"></SelectItems>
                </v-flex>
                <v-flex xs12>
                  <EmailCombobox ref="emails"></EmailCombobox>
                </v-flex>
              </v-layout>
            </form>
            <div v-if="type === 'detail'">
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>fa-calendar</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Fecha de realización</v-list-tile-title>
                  <v-list-tile-sub-title><b>{{ movimiento.created }}</b></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>fa-list</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Tipo de movimiento</v-list-tile-title>
                  <v-list-tile-sub-title><b>{{ movimiento.type }}</b></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>fa-comment</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Detalle del movimiento</v-list-tile-title>
                  <v-list-tile-sub-title><b>{{ movimiento.description }}</b></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>fa-user</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Autor del movimiento</v-list-tile-title>
                  <v-list-tile-sub-title><b>{{ movimiento.author }}</b></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>notifications</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Notificado</v-list-tile-title>
                  <v-list-tile-sub-title><b>{{ movimiento.notified ? 'Sí' : 'No' }}</b></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list v-if="movimiento.poseeAdjuntos !== 'No'">
                <v-list-group>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>attach_file</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Archivos adjuntos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                  <v-list-tile v-for="asset in movimiento.assets" :key="asset.id">
                    <v-list-tile-content>
                      <v-list-tile-title><a target="_blank" :href="asset.url">{{ asset.name }}</a></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
              </v-list>
              <v-list v-if="movimiento.notificados.length !== 0">
                <v-list-group>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-avatar>
                        <v-icon>fa-envelope</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Usuarios notificados</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                  <v-list-tile v-for="notificado in movimiento.notificados" :key="notificado.id">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ notificado.name }} - <a>{{ notificado.email }}</a> </v-list-tile-title>
                      <v-list-tile-sub-title>Notificado el día: {{ notificado.created }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
              </v-list>
            </div>
            <br>
            <v-btn color="blue-grey-lighten-4" @click="closeDialog">Volver</v-btn>
            <v-btn v-if="type === 'notification'" @click="submit" color="primary" :disabled="saving">Crear</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import EmailCombobox from '../../../common/ui/EmailCombobox'
import SelectItems from '../../../common/ui/SelectItems'
import { recipientsMixin } from '../../../mixins/recipientsMixin'

export default {
  mixins: [validationMixin, s3UploadMixin, recipientsMixin],

  validations: {
  },

  components: {
    EmailCombobox,
    SelectItems
  },

  props: {
    cardTitle: null,
    cardDetail: null,
    type: null,
    clubId: null,
    movimiento: null
  },

  data () {
    return {
      loading: false,
      saving: false,
      title: '',
      departamento: null,
      cuerpo: '',
      items: [],
      files: [],
      file: null,
      dialog: false
    }
  },
  computed: {
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        const payload = {
          person_criteria: this.personas,
          clubes: this.clubId,
          emails: this.$refs.emails.getEmails()
        }
        this.axios
          .patch(`/expedientes/movimientos/notificar/${this.movimiento}`, payload)
          .then((response) => {
            this.$router.go()
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    showDialog () {
      this.dialog = true
      this.clubes = this.clubId
    },
    closeDialog () {
      this.dialog = false
    }
  },
  created () {
    this.loading = true
    // this.fetchData()
  },
  mounted () {

  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.4em;
  color: rgb(99, 95, 95);
  padding-top: 1.5em;
  margin-top: 2em;
}

.partido-title {
  color: lightslategray;
  font-size: 1.8em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
